import React from "react";
import {
  PoundSterling, Users2, Workflow, TrendingUp, Trophy, Sparkles,
} from "lucide-react";
import { marketplaceKpis } from "../../data/marketplaceData";

const cards = [
  { key: "monthlyRevenue",  label: "Monthly referral revenue",  icon: PoundSterling, tone: "emerald" },
  { key: "activePartners",  label: "Active partner services",   icon: Users2,        tone: "blue" },
  { key: "referralsLive",   label: "Transactions supported",    icon: Workflow,      tone: "violet" },
  { key: "conversion",      label: "Referral conversion",       icon: TrendingUp,    tone: "emerald" },
  { key: "topPerformer",    label: "Top-performing partner",    icon: Trophy,        tone: "amber" },
  { key: "aiSuggestions",   label: "AI partner recommendations",icon: Sparkles,      tone: "emerald" },
];

const tones = {
  emerald: "bg-indigo-50 text-indigo-700",
  blue: "bg-blue-50 text-blue-700",
  violet: "bg-indigo-50 text-indigo-700",
  amber: "bg-amber-50 text-amber-700",
};

export const MarketplaceHeader = () => {
  return (
    <header className="sticky top-0 z-30 glass-light border-b cf-divider-soft" data-testid="marketplace-header">
      <div className="px-4 md:px-10 pt-6 md:pt-9 pb-5 flex items-end justify-between gap-4 flex-wrap">
        <div>
          <span className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.22em] text-indigo-700 mb-2">
            <span className="w-1.5 h-1.5 rounded-full bg-indigo-500 cf-pulse" />
            Network
          </span>
          <h1 className="cf-h-page" data-testid="marketplace-title">Service Marketplace</h1>
          <p className="text-[13px] text-slate-500 mt-2">Curated partners powering every transaction · revenue-share enabled</p>
        </div>
        <div className="flex items-center gap-2">
          <button data-testid="invite-partner-btn" className="btn btn-secondary">Invite partner</button>
          <button data-testid="new-referral-btn" className="btn btn-primary">+ New referral</button>
        </div>
      </div>
      <div className="px-4 md:px-10 pb-5 md:pb-7 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 cf-stagger">
        {cards.map((c) => {
          const k = marketplaceKpis[c.key];
          const Icon = c.icon;
          return (
            <div
              key={c.key}
              data-testid={`mkt-kpi-${c.key}`}
              className="cf-kpi"
            >
              <div className="flex items-center justify-between">
                <div className={`w-7 h-7 rounded-lg ${tones[c.tone]} flex items-center justify-center`}>
                  <Icon size={13} strokeWidth={1.8} />
                </div>
                <span className="text-[10px] uppercase tracking-[0.14em] text-indigo-600 font-semibold">{k.trend}</span>
              </div>
              <p className="font-display text-[22px] font-bold text-slate-900 mt-5 leading-none tracking-[-0.025em]">{k.value}</p>
              <p className="text-[11px] text-slate-500 mt-1.5 leading-tight">{c.label}</p>
              <p className="text-[10px] uppercase tracking-[0.14em] text-slate-400 font-semibold mt-1.5">{k.sub}</p>
            </div>
          );
        })}
      </div>
    </header>
  );
};
